'use client';
import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import React from "react";
import { IBanner } from "@/services/types";
import { HeroSlideContent } from "./HeroSlideContent";
import { HeroNavigation } from "./HeroNavigation";

// Função para limpar HTML e manter apenas texto
const stripHtml = (html: string): string => {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '').trim();
};

interface HeroCarouselProps {
    slidesBanner: IBanner[];
}

export default function HeroCarousel({ slidesBanner }: HeroCarouselProps) {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isMounted, setIsMounted] = useState(false);

    const totalSlides = slidesBanner.length;

    useEffect(() => {
        setIsMounted(true);
    }, []);

    useEffect(() => {
        if (!isMounted) return;

        const timer = setTimeout(() => {
            setCurrentSlide((prev) => (prev + 1) % totalSlides);
        }, 9000);
        return () => clearTimeout(timer);
    }, [currentSlide, totalSlides, isMounted]);

    if (!slidesBanner || slidesBanner.length === 0) return null;

    const currentBanner = slidesBanner[currentSlide];

    return (
        <>
            <div className="relative w-full flex items-end" suppressHydrationWarning>
                <div className="relative min-h-[650px] sm:min-h-[700px] md:min-h-[750px] lg:h-[960px] w-full flex items-end mb-34">
                    <div className="w-full min-h-[450px] sm:min-h-[500px] md:h-[750px] lg:h-[960px]">
                        {/* Conteúdo com slide */}
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={`content-${currentSlide}`}
                                initial={isMounted ? { x: "100%", opacity: 0 } : undefined}
                                animate={{ x: 0, opacity: 1 }}
                                exit={isMounted ? { x: "-100%", opacity: 0 } : undefined}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                                className="absolute inset-0 z-20 flex flex-col lg:flex-row justify-center items-center"
                            >
                                <HeroSlideContent
                                    banner={currentBanner}
                                    totalSlides={totalSlides}
                                    currentSlide={currentSlide}
                                    onSlideChange={setCurrentSlide}
                                    stripHtml={stripHtml}
                                />
                            </motion.div>
                        </AnimatePresence>

                        {/* Navegação por pontos - Desktop */}
                        <HeroNavigation
                            totalSlides={totalSlides}
                            currentSlide={currentSlide}
                            onSlideChange={setCurrentSlide}
                            variant="desktop"
                        />

                        {/* Elemento decorativo - Imagem de fundo */}
                        <div 
                            className="absolute -top-2 left-0 right-0 h-full lg:h-[1000px] xl:h-[1050px]  z-10 pointer-events-none
                                       bg-[url('/HEADER.png')] bg-cover bg-center opacity-50"
                        />

                        {/* Código SVG original comentado
                        <div className="absolute -top-2 left-0 right-0 z-10 pointer-events-none">
                            <svg
                                viewBox="0 0 375 200"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-full h-auto lg:hidden"
                                preserveAspectRatio="none"
                            >
                                <path
                                    d="M0 0H375V150C280 180 95 180 0 150V0Z"
                                    fill="#E8E5DC"
                                    fillOpacity="0.6"
                                />
                            </svg>

                            <svg
                                width="1920"
                                height="1251"
                                viewBox="0 0 1920 1251"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-full h-auto hidden lg:block"
                            >
                                <mask id="mask0_2054_72806" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="1920" height="952">
                                    <path d="M0 10H1920V871.342C1001.16 1119.69 789.954 762.196 0 915.504V10Z" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_2054_72806)">
                                    <rect x="-146" width="2252.92" height="1251" fill="url(#pattern0_2054_72806)" fillOpacity="0.5" />
                                </g>
                                <path d="M-1 915.445C406.97 836.145 660.659 893.226 937.075 932.798C661.937 1045.28 371.464 1134.52 -1 922.042V915.445ZM937.075 932.798C1251.33 804.328 1545.58 645.55 1919.14 871.422C1474.86 991.568 1196 969.865 937.075 932.798ZM1920 871.939C1919.71 871.766 1919.43 871.595 1919.14 871.422C1919.43 871.345 1919.71 871.268 1920 871.19V871.939ZM1920 9H-1V8.03906H1920V9Z" fill="#1F1E1E" fillOpacity="0.1" />
                                <defs>
                                    <pattern id="pattern0_2054_72806" patternContentUnits="objectBoundingBox" width="1" height="1">
                                        <use href="#image0_2054_72806" transform="scale(0.000520833 0.00118765)" />
                                    </pattern>
                                    <image id="image0_2054_72806" width="1920" height="1952" preserveAspectRatio="none" href="/bg-header.png" />
                                </defs>
                            </svg>
                        </div>
                        */}
                    </div>
                </div>
            </div>
        </>
    );
}